<div class="scrubber-container">
  <div class="controller-group-container">
    <div class="button-group-container">
      <div class="button-container" *ngIf="isSmartSkipOn">
        <button
          mat-button
          (click)="smartSkipBackward()"
          [matTooltip]="smartSkipBackwardTooltip"
          [disabled]="(frameNumber$ | async) === 0"
        >
          <mat-icon class="material-symbols-outlined">first_page</mat-icon>
        </button>
      </div>
      <div class="button-container">
        <button
          mat-button
          (click)="scrubWithButton(-5, 'skip_backward')"
          [matTooltip]="skipBackwardTooltip"
          [disabled]="(frameNumber$ | async) === 0"
        >
          <mat-icon class="material-symbols-outlined" [inline]="false"
            >keyboard_double_arrow_left</mat-icon
          >
        </button>
      </div>
      <div class="button-container">
        <button
          mat-button
          (click)="scrubWithButton(-1, 'back')"
          [matTooltip]="backwardTooltip"
          [disabled]="(frameNumber$ | async) === 0"
        >
          <mat-icon class="material-symbols-outlined">navigate_before</mat-icon>
        </button>
      </div>
      <ng-container *ngIf="framesPerSecond">
        <div class="button-container" *ngIf="(isPlaying$ | async) === false">
          <button
            mat-button
            (click)="playButtonPressed()"
            [matTooltip]="playTooltip"
            [disabled]="(frameNumber$ | async) === (maxFrameNumber$ | async)"
          >
            <mat-icon class="material-symbols-outlined">play_arrow</mat-icon>
          </button>
        </div>
        <div class="button-container" *ngIf="isPlaying$ | async">
          <button
            mat-button
            (click)="pauseButtonPressed()"
            [matTooltip]="pauseTooltip"
          >
            <mat-icon class="material-symbols-outlined"
              >pause_circle_outline</mat-icon
            >
          </button>
        </div>
      </ng-container>
      <div class="button-container">
        <button
          mat-button
          (click)="scrubWithButton(1, 'forward')"
          [matTooltip]="forwardTooltip"
          [disabled]="(frameNumber$ | async) === (maxFrameNumber$ | async)"
        >
          <mat-icon class="material-symbols-outlined">navigate_next</mat-icon>
        </button>
      </div>
      <div class="button-container">
        <button
          mat-button
          (click)="scrubWithButton(5, 'skip_forward')"
          [matTooltip]="skipForwardTooltip"
          [disabled]="(frameNumber$ | async) === (maxFrameNumber$ | async)"
        >
          <mat-icon class="material-symbols-outlined"
            >keyboard_double_arrow_right</mat-icon
          >
        </button>
      </div>
      <div class="button-container" *ngIf="isSmartSkipOn">
        <button
          mat-button
          (click)="smartSkipForward()"
          [matTooltip]="smartSkipForwardTooltip"
          [disabled]="(frameNumber$ | async) === (maxFrameNumber$ | async)"
        >
          <mat-icon class="material-symbols-outlined">last_page</mat-icon>
        </button>
      </div>
    </div>

    <span class="focused-range" *ngIf="focusedAreaRange$ | async as range">
      {{ range[0] }}-{{ range[1] }} /
      {{ maxFrameNumber$ | async }}
    </span>

    <!-- ranges don't like being styled, so style a wrapper -->
    <span class="enhanced-timeline">
      <input
        type="range"
        min="0"
        #slider
        [max]="maxFrameNumber$ | async"
        [ngModel]="frameNumber$ | async"
        (ngModelChange)="onSliderChange(+slider.value)"
      />

      <h3-focusable-timeline
        [shapeStore]="focusedShapeStore$ | async"
      ></h3-focusable-timeline>
      <h3-frame-loading-bar></h3-frame-loading-bar>
      <h3-scrubber-cursor></h3-scrubber-cursor>
      <h3-focused-area></h3-focused-area>
    </span>
    <span class="frame-number-input">
      <input
        #frameNumber
        type="number"
        matInput
        [ngModel]="frameNumber$ | async"
        (click)="$event.preventDefault()"
        (keydown.enter)="moveToFrame(+frameNumber.value)"
        matTooltip="Enter a frame number and press 'Enter' to go directly to a frame"
      />
    </span>
  </div>
  <h3-focused-timeline></h3-focused-timeline>
</div>
